module.exports = __webpack_public_path__ + "img/underline-black.0bd71b7.svg";